import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../../shared/base-api-template-service.model';
import { Core2Config } from '../../../shared/core2Config';
import { BaseApiPublicLoginTemplateService } from '../../../shared/base-api-public-login-template.service';
import { ApiVisa, BasicApiResponseModel } from '../../../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChinaWareHouseApiService extends BaseApiPublicLoginTemplateService<any, any, any> {
  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'tnl-china-warehouse-api';
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'tnl-china-warehouse-api';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'tnl-china-warehouse-api';
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'tnl-china-warehouse-api/' + BaseApiTemplateService.PUBLIC_EP;
    this.httpClient = http;
  }

   public getByPONumber(
      poNumber: string,
      visa: ApiVisa
    ): Observable<BasicApiResponseModel<any>> {
      if (this.endpoint_path_public_url && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path_public_url;
      }
      return this.httpClient.get<BasicApiResponseModel<any>>(
        this.apiUrl + '/' + poNumber,
        this.getHttpHeader(visa)
      );
    }
}